import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion'
import Filter from './filter'
import EmailList from './emailList'
import http from '../services/httpService'

const apiCompany = 'companies';
const apiParentCategories = 'parent_categories';

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.filters = {};
    this.state[apiCompany] = [];
    this.state.availableFilters = [];
  }

  async getAvailableFilters() {
    const apiEndpoint = apiParentCategories;
    const { data } = await http.get(apiEndpoint);
    this.setState({ availableFilters: data.parent_categories })
  }

  async getFilterOptions(resource) {
    const apiEndpoint = resource;
    const { data } = await http.get(apiEndpoint);
    let obj = {};
    obj[resource] = data[resource];
    this.setState(obj);
  }

  async componentDidMount() {
    this.getAvailableFilters();
    this.getFilterOptions(apiCompany);
  }

  handleFilterSelect = (type, e) => {
    const filters = {...this.state.filters};
    if (e.target.checked) {
      if (!(type in filters)) {
        filters[type] = [];
      }

      filters[type] = filters[type].concat(e.target.name);
      this.setState({ filters }, () => console.log(this.state.filters));
    }
    else {
      filters[type] = filters[type].filter(instance => instance !== e.target.name);
      if (!filters[type].length) {
        delete filters[type];
      }
      this.setState({ filters }, () => console.log(this.state.filters));
    }
  }

  render() {
    const { user, sidebarOpen, onSidebarOpen } = this.props;
    return (
        <React.Fragment>
        {/*<div className="text-center py-4 col-12 col-lg-4 m-auto">
          <img className="main-logo w-100" src="black_logo.svg" />
        </div>*/}
            { sidebarOpen &&
                <div className="bg-white sidenav sidenav-width">
                  <div className="sidenav-filters">
                      <h5 className="text-primary pl-3 pb-1">Filters</h5>
                      <button
                        type="button"
                        className="close-button-size close text-primary mx-2 mb-3"
                        aria-label="Close"
                        onClick={ () => { onSidebarOpen(false) } }>
                        <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div className="sidenav-content">
                    <Accordion>
                      <Filter
                        label='name'
                        name={ apiCompany }
                        type={ apiCompany }
                        instances={ this.state.companies }
                        selected_instances={ this.state.filters }
                        onFilterSelect={ this.handleFilterSelect } />
                      { this.state.availableFilters.map(
                          availableFilter =>
                          <Filter
                            key={ availableFilter.name }
                            label='name'
                            name={ availableFilter.name }
                            type="email_categories"
                            instances={ availableFilter.child_categories }
                            selected_instances={ this.state.filters }
                            onFilterSelect={ this.handleFilterSelect } />
                          )
                      }
                    </Accordion>
                  </div>
                </div>}
            <div className="container">
              <div className="row justify-content-center">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={ () => { onSidebarOpen(!sidebarOpen) } }>
                  Filters
                </button>
              </div>
              {!user && <div className="register-cta">
                Want more results?&nbsp;
                  <Link className="text-rubyred" to="/register">
                    <strong>Register</strong>
                  </Link>
                &nbsp;now to get access to millions of marketing emails!
              </div>}
                <EmailList
                  user={ user }
                  filters={ this.state.filters }
                  parentCategories={ this.state.availableFilters }/>
            </div>
        </React.Fragment>
    );
  }
}

export default HomePage;
